import React from 'react';
import {
  Col, Row,
} from 'react-bootstrap';
import useDeleteContractAttachment from 'utils/hooks/companies/useDeleteContractAttachment';
import { ContractAttachment } from 'helper/contracts';
import useConfirmationDialogBox from 'utils/useConfirmationDialogBox';
import DownloadButton from 'components/DownloadButton';
import ActionButton from 'components/ActionButton';
import { downloadContractBlob } from 'services/fileDownloadApi';
import confirmationDialog from './utils';

export default function AttachmentRow(
  { attachment }: { attachment: ContractAttachment },
) {
  const {
    isLoading,
    deleteContractAttachment,
  } = useDeleteContractAttachment({ attachmentId: attachment.id });
  const { confirmationDialogBox, setConfirmationDialogBox } = useConfirmationDialogBox();
  const onClick = () => setConfirmationDialogBox(
    true,
    confirmationDialog,
    deleteContractAttachment,
  );

  return (
    <>
      {confirmationDialogBox}
      <Row className="attached-file align-items-center">
        <Col>
          {attachment.originalFilename}
        </Col>
        <Col>
          <Row xs="auto">
            <Col>
              <DownloadButton
                blobDownloader={downloadContractBlob}
                params={attachment.id}
                filename={attachment.originalFilename}
                tooltipText={attachment.originalFilename}
                className=""
              />
            </Col>
            <Col>
              <ActionButton
                id={`delete-attachment-${attachment.id}`}
                loading={isLoading}
                onClick={onClick}
                tooltipText="Deletar arquivo"
                icon="trash"
                type="secondary"
                small={false}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
}
